import React from 'react';
import { Star, Paperclip } from 'lucide-react';
import { Email } from '../../../types/email';
import { formatDate } from '../../../utils/formatters';

interface EmailListProps {
  emails: Email[];
  onEmailSelect: (email: Email) => void;
  onStarToggle: (emailId: string) => void;
}

export default function EmailList({ emails, onEmailSelect, onStarToggle }: EmailListProps) {
  return (
    <div className="divide-y divide-gray-200">
      {emails.map((email) => (
        <div
          key={email.id}
          onClick={() => onEmailSelect(email)}
          className={`p-4 hover:bg-gray-50 cursor-pointer ${
            !email.isRead ? 'bg-blue-50' : ''
          }`}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4 flex-1">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onStarToggle(email.id);
                }}
                className={`p-1 rounded-full hover:bg-gray-100 ${
                  email.isStarred ? 'text-yellow-400' : 'text-gray-400'
                }`}
              >
                <Star className="w-5 h-5" />
              </button>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between">
                  <p className={`text-sm font-medium ${!email.isRead ? 'text-gray-900' : 'text-gray-600'}`}>
                    {email.from}
                  </p>
                  <p className="text-sm text-gray-500 ml-2">
                    {formatDate(email.timestamp)}
                  </p>
                </div>
                <h3 className={`text-base ${!email.isRead ? 'font-semibold text-gray-900' : 'font-medium text-gray-700'}`}>
                  {email.subject}
                </h3>
                <p className={`mt-1 text-sm line-clamp-2 ${!email.isRead ? 'text-gray-800' : 'text-gray-600'}`}>
                  {email.content}
                </p>
                {email.labels && email.labels.length > 0 && (
                  <div className="mt-2 flex items-center space-x-2">
                    {email.labels.map((label) => (
                      <span
                        key={label}
                        className="px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800"
                      >
                        {label}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {email.hasAttachments && (
              <div className="ml-4">
                <Paperclip className="w-5 h-5 text-gray-400" />
              </div>
            )}
          </div>
        </div>
      ))}
      
      {emails.length === 0 && (
        <div className="p-8 text-center text-gray-500">
          No emails found
        </div>
      )}
    </div>
  );
}